export const SCOPE_VENUES = "venues";
export const SCOPE_TEAM = "team";

export const STATUS_DRAFT = "draft";
export const STATUS_PUBLISHED = "published";
export const STATUS_ARCHIVED = "archived";

export const STATUS_LABELS = {
  [STATUS_DRAFT]: "Draft",
  [STATUS_PUBLISHED]: "Published",
  [STATUS_ARCHIVED]: "Archived",
};

export const STATUS_COLORS = {
  [STATUS_DRAFT]: "gray",
  [STATUS_PUBLISHED]: "success",
  [STATUS_ARCHIVED]: "gray",
};

export const formatCents = (cents, currency, { whole = false } = {}) => {
  const amount = (cents || 0) / 100;
  const digits = whole && Number.isInteger(amount) ? 0 : 2;
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currency || "USD",
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  }).format(amount);
};

export const formatAmounts = ({ denominationsCents = [], customMinCents, customMaxCents }, currency) => {
  const parts = denominationsCents.map((cents) => formatCents(cents, currency, { whole: true }));
  if (customMinCents && customMaxCents) {
    parts.push(
      `${formatCents(customMinCents, currency, { whole: true })}–${formatCents(customMaxCents, currency, { whole: true })}`
    );
  }
  return parts.length > 0 ? parts.join(" · ") : "—";
};

export const scopeLabel = (scope, venueNames = []) => {
  if (scope === SCOPE_TEAM) return "Any team venue";
  return venueNames.length > 0 ? venueNames.join(", ") : "No venues picked";
};
